declare const ym: any;

type Goal = "buy-click" | "buy" | "cancel" | "login" | "gen";
const reachedGoals: { [goal: string]: boolean } = {};

export function reachGoal(goal: Goal) {
    try {
        if (reachedGoals[goal] !== true) {
            ym(27763311, "reachGoal", goal);
        }
    } catch (e) {
        // ignore
    }
}
